<template>
  <div class="apps">
    <div class="banner">
      <img src="@/assets/img/bg/hand.png" alt="" />
    </div>
    <el-breadcrumb class="mianbao" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/page/index' }"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item :to="{ path: '/page/index/shop' }"
        >产品中心</el-breadcrumb-item
      >
      <el-breadcrumb-item>{{ goods.title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content" v-if="is">
      <div class="shang">
        <div class="left">
          <div class="logo">
            <img :src="goods.show_img" alt="" />
          </div>
          <div class="text">{{ goods.t_desc }}</div>
        </div>
        <div class="right">
          <div class="tt">
            {{ goods.title }}
          </div>
          <div class="con" v-html="goods.content"></div>
          <div class="tel">
            {{ goods.desc }}
          </div>
        </div>
      </div>

      <div class="xia">
        <div class="img_boxs">
        <div v-if="isArray" class="img_boxs">
            <div
            class="img_box"
            v-for="(item, index) in goods.logo"
            :key="item + index"
            @click="clickSmaImg(item, index)"
          >
            <img :src="item" alt="" />
          </div>
        </div>
          <div v-if="isString" class="img_box">
            <img :src="goods.logo" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="no" v-else>暂无内容</div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      goods: {},
      mianbao: {},
      is: true, // 无内容不显示
      prePath: "",
    };
  },

  methods: {
    getData() {
      axios({
        url:
          this.base_url.base_url +
          "/index.php/index/index/goods_list",
          data:{
            keyword:this.$route.query.keyword
          },
          method: "post",
      })
        .then((res) => {
          if (!res.data.data.goods_data[0]) {
            this.is = false;
            return;
          }
          this.is = true;
          this.goods = res.data.data.goods_data[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getidData() {
      axios({
        url:
          this.base_url.base_url +
          `/index.php/index/index/goods_detail?nid=${this.$route.query.id}`,
        method: "get",
      })
        .then((res) => {
          console.log(res);
          this.goods = res.data.data.goods_data;
          if (typeof this.goods.logo === "string") {
            this.goods.logo = [this.goods.logo];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clickSmaImg(item) {
      console.log(item);
      try {
        // let img = this.goods.show_img;
        this.goods.show_img = item;
        // this.goods.logo[index] = img;
      } catch (error) {
        console.log(error);
      }
    },
  },
  computed:{
    isString(){
        return typeof this.goods.logo == 'string'
    },
    isArray() {
      return Array.isArray(this.goods.logo);
    }
  },
  created() {
    console.log(encodeURIComponent(this.$route.query.keyword),'455');
    if (this.$route.query.keyword) {
      this.getData();
    } else if (
      this.$route.query.cid &&
      this.$route.query.rid &&
      this.$route.query.i
    ) {
      this.getidData();
    }
  },
};
</script>

<style scoped lang="scss">
.apps {
  display: flex;
  flex-direction: column;

  .banner {
    height: 100%;

    img {
      width: 100%;
    }
  }

  .mianbao {
    width: 1306px;
    height: 77px;
    margin: 0 auto;
    line-height: 77px;
    border-bottom: 1px solid #e4edf3;

    .el-breadcrumb__inner {
      cursor: pointer;
    }
  }

  .content {
    width: 1306px;
    height: 660px;
    // background: #FFFFFF;
    margin: 82px auto 262px;
    // opacity: 1;

    .shang {
      // width: 1306px;
      // height: 300px;
      margin: 0 auto;
      display: flex;

      .left {
        width: 660px;
        height: 550px;
        background: #ffffff;
        opacity: 1;
        border: 2px solid #dae6ef;
        position: relative;
        margin-right: 40px;

        .logo {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 305px;
          height: 450px;

          img {
            width: 305px;
            height: 450px;
            object-fit: contain;
          }
        }

        .text {
          position: absolute;
          bottom: 0;
          width: 383px;
          font-size: 16px;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: 400;
          color: #000;
          line-height: 30px;
          padding: 0 20px;
          background-color: #f4f8fb;
        }
      }

      .right {
        width: 100%;
        display: flex;
        flex-direction: column;

        .tt {
          border-bottom: 2px solid #dae6ef;
          height: 60px;
          line-height: 60px;
          font-size: 32px;
          color: #3e3a39;
          padding: 0 10px;
        }

        .con {
          border-bottom: 2px solid #dae6ef;
          padding: 30px 10px;
          // height: 60px;
          // line-height: 60px;
          font-size: 32px;
          color: #3e3a39;
          flex: 1;
        }

        .tel {
          border-bottom: 2px solid #dae6ef;
          height: 60px;
          line-height: 60px;
          font-size: 24px;
          color: #234ce2;
        }
      }
    }

    .xia {
      width: 90px;
      height: 90px;
      margin-bottom: 60px;

      .img_boxs {
        display: flex;

        .img_box {
          cursor: pointer;
          img {
            width: 90px;
            height: 90px;
            object-fit: contain;
          }
        }
      }
    }

    .back {
      margin-top: 30px;
      width: 1306px;
      height: 60px;
      margin: 30px auto 40px;
      background-color: #f4f8fb;
      text-align: center;
      line-height: 60px;
      cursor: pointer;
    }
  }
}
</style>
